import { createSelector } from '@reduxjs/toolkit';

import { initialState } from './slice';

// First select the relevant part from the state
const selectDomain = state => state.companyAdd || initialState;

export const selectDropdowns = createSelector(
  [selectDomain],
  state => state.dropdowns,
);

export const selectCountries = createSelector(
  [selectDomain],
  state => state.countries,
);

export const selectStates = createSelector(
  [selectDomain],
  state => state.states,
);

export const selectCities = createSelector(
  [selectDomain],
  state => state.cities,
);

export const selectPaymentMethods = createSelector(
  [selectDomain],
  state => state.paymentMethods,
);

export const selectLoading = createSelector(
  [selectDomain],
  state => state.loading,
);

export const selectError = createSelector(
  [selectDomain],
  state => state.error,
);